import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router from '@/router'
import { useAppStore } from '@/stores/app'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        baseUrl: '',
        options: {
            beforeFetch({ options }) {
                const token = appStore.getJWT()
                if (token) {
                    options.headers = {
                        ...options.headers,
                        Authorization: `Bearer ${token}`,
                    }
                }
                return { options }
            },
            async onFetchError(ctx) {
                if (ctx.response?.status === 401) {
                    appStore.setLogout()
                    await router.push({ name: 'login' })
                }
                return ctx
            },
        },
    })

    return { fetch }
})
